export const PostInstructFxStatus = {
  INITIATED: 'INITIATED',
  EXECUTED: 'EXECUTED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  RETURNED: 'RETURNED',
  RESUBMITTED: 'RESUBMITTED',
  REFUNDED: 'REFUNDED',
};
